
import $ from "jquery";


import Navbar from './view/navbar'; // Adjust the path as needed




import React, { useState, useEffect } from "react";
import LoadingScreen from "./view/LoadingScreen";
import { AgentAuthProvider } from "./view/Agent/AgentAuthContext";


const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // Hide loading after 1.5s
    }, 4000);
  }, []);

  return (
    <>
       <AgentAuthProvider>
      {loading ? (
        <LoadingScreen />
      ) : (
        <Navbar />
      )}
      </AgentAuthProvider>
    </>
  );
};

export default App;

